export const defaultTheme = {
  colors: {
    verdigris: '#58C3BB',
    verdigrisDark: '#4FADA6',
    oxfordBlue: '#071C3E',
    oxfordBlueDark: '#08142f', // Old color - Created while we haven't decided yet (Welcome page)
    white: '#FFFFFF',
    titleBlue: '#031C38',
    mintGreen: '#D7F7F5',
    mintCream: '#F1FAF9',
    lavender: '#D4DEED',
    battleShipGray: '#919191',
    eerieBlack: '#1F1F1F',
    rustyRed: '#CC3044',
    dimGray: '#717171',
    platinum: '#E1E1E1',
    platinumDark: '#D9D9D9',
    redCrayola: '#EF374E',
    azure: '#007AFF',
    antiFlashWhite: '#F1F1F1',
    seasalt: '#F8F8F8',
    silver: '#B1B1B1',
    aquaBlue: '#D4EDEB',
    darkBlue: '#061733',
    amber: '#FBBC05',
    denim: '#8298B5',
    deepTeal: '#006961',
    tangerine: '#E7822A',
    mint: '#EEF9F8',
    transparent: 'transparent',
    error: '#DC3545',
    textSecondary: '#6C757D',
  },
  colorsInObjects: {
    gray: {
      900: '#1F1F1F',
      800: '#717171',
      700: '#919191',
      600: '#D9D9D9',
      200: '#F8F8F8',
      opacity: 'rgba(31, 31, 31, 0.7)',
    },
    blue: {
      900: 'rgba(123, 131, 140, 0.9)',
      800: 'rgba(123, 131, 140, 0.8)',
      700: 'rgba(123, 131, 140, 0.7)',
      500: '#8298B5',
      300: '#D6DEEC',
    },
    yellow: {
      500: '#FBBC05',
      300: '#F8E58A',
    },
    mint: {
      900: '#58C3BB',
      200: '#EEF9F8',
      300: '#DEF6F5',
      500: '#ABE1DD',
    },
    opacity: {
      dark: 'rgba(31,31,31,0.9)',
    },
  },
  radius: {
    xs: '0.25rem',
    s: '0.5rem', // 8px
    m: '0.75rem', // 12px
    l: '1rem', // 16px
    xl: '1.875rem', // 30px
  },
  flex: {
    full: 1,
  },
  font: {
    default: 'Source Sans Pro',
  },
  fontSize: {
    xxs: '10px',
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '28px',
  },
  fontWeight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900,
  },
  width: {
    full: '100%',
    half: '50%',
    quarter: '25%',
  },
  height: {
    h1: '0.25rem',
    h2: '0.5rem',
    h3: '0.75rem',
    h4: '1rem', // 16px
    h5: '2rem', // 32px
    h6: '3rem', // 48px
    h7: '4rem', // 64px
    footer: '83px',
    full: '100%',
  },
  spacing: {
    none: '0',
    xxs: '2px',
    xs: '4px',
    s: '8px',
    sm: '12px',
    m: '16px',
    md: '20px',
    xm: '24px',
    l: '32px',
    xl: '40px',
    xxl: '64px',
  },
  positions: {
    relative: 'relative',
    absolute: 'absolute',
  },
  display: {
    flex: 'flex',
  },
  justifyContent: {
    spaceBetween: 'space-between',
  },
  lineHeight: {
    lh1: '36px',
    lh2: '30px',
    lh3: '24px',
    lh4: '20px',
    lh5: '18px',
    lh6: '16px',
    lh7: '14px',
  },
  zindex: {
    z0: 0,
    z10: 10,
    z20: 20,
    z30: 30,
    z40: 40,
    z50: 50,
    z100: 100,
    z110: 110,
  },
};
